import { createAction, props } from '@ngrx/store';

import { Calendar } from 'src/app/model/calendar';
import { CalendarException } from 'src/app/model/calendar-exception';


export const getCalendars = createAction('GET_CALENDARS', props<{ siteId: number }>());
export const getCalendarsSuccess = createAction('GET_CALENDARS_SUCCESS', props<{ calendars: Calendar[] }>());
export const getCalendarsFailed = createAction('GET_CALENDARS_FAILED', props<{ errorMessage: string }>());

export const resetCalendarDialog = createAction('RESET_CALENDAR_DIALOG');
export const addCalendar = createAction('ADD_CALENDAR', props<{ calendar: Calendar }>());
export const addCalendarSuccess = createAction('ADD_CALENDAR_SUCCESS', props<{ message: string; calendar: Calendar }>());
export const addCalendarFailed = createAction('ADD_CALENDAR_FAILED', props<{ errorMessage: string }>());

export const editCalendar = createAction('EDIT_CALENDAR', props<{ calendar: Calendar }>());
export const editCalendarSuccess = createAction('EDIT_CALENDAR_SUCCESS', props<{ message: string; calendar: Calendar }>());
export const editCalendarFailed = createAction('EDIT_CALENDAR_FAILED', props<{ errorMessage: string }>());

export const deleteCalendar = createAction('DELETE_CALENDAR', props<{ calendarId: number }>());
export const deleteCalendarSuccess = createAction('DELETE_CALENDAR_SUCCESS', props<{ message: string; id: number }>());
export const deleteCalendarFailed = createAction('DELETE_CALENDAR_FAILED', props<{ errorMessage: string }>());

export const getExceptions = createAction('GET_EXCEPTIONS');
export const getExceptionsSuccess = createAction('GET_EXCEPTIONS_SUCCESS', props<{ exceptions: CalendarException[] }>());
export const getExceptionsFailed = createAction('GET_EXCEPTIONS_FAILED', props<{ errorMessage: string }>());

export const addException = createAction('ADD_EXCEPTION', props<{ exception: CalendarException }>());
export const addExceptionSuccess = createAction('ADD_EXCEPTION_SUCCESS', props<{ exception: CalendarException, message: string; }>());
export const addExceptionFailed = createAction('ADD_EXCEPTION_FAILED', props<{ errorMessage: string }>());

export const deleteException = createAction('DELETE_EXCEPTION', props<{ exceptionId: number }>());
export const deleteExceptionSuccess = createAction('DELETE_EXCEPTION_SUCCESS', props<{ message: string; id: number }>());
export const deleteExceptionFailed = createAction('DELETE_EXCEPTION_FAILED', props<{ errorMessage: string }>());

export const calendarBigWarning = createAction('CALENDAR_BIG_WARNING', props<{ message: string }>());
